module.exports = __webpack_public_path__ + "assets/note.b02d9a6b.svg";